export default __webpack_public_path__ + "static/media/loader-indicator.1475d73c.svg";